<div soho-busyindicator [text]= "'Loading' | translate" class="lm-columnar-adhoc-report">
  <div [class.header-border]="true"
      [class.overlay-toolbar]="true">
    <lm-toolbar
        [toolbarIdPrefix]="'adhocReportToolbar'"
        [automationId]="'adhocReportToolbar'"
        [inHeader]="false"
        [isInOverlay]="true"
        [showOverlayBackButton]="false"
        [allowOverlayInteractions]="false"
        [sectionTitle]="flyoutTitle"
        [buttons]="toolbarButtons"
        [showCalledOutMenuButton]="false"

        (toolbarButtonEvent)="onToolbarButtonEvent($event)"
    ></lm-toolbar>
  </div>
  <div class="lm-columnar-adhoc-report-tabs">
    <div soho-tabs [headerTabs]="true">
      <div soho-tab-list-container>
        <ul soho-tab-list>
          <li soho-tab>
            <a soho-tab-title
               tabId="tabs-columnar-dimensions"
               data-automation-id="lm-columnar-adhoc-dimensions-tab">
              Dimensions
            </a>
          </li>
          <li soho-tab>
            <a soho-tab-title
               tabId="tabs-columnar-measures"
               data-automation-id="lm-columnar-adhoc-measures-tab">
              Measures
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div soho-tab-panel tabId="tabs-columnar-dimensions">
      @if (refreshTabPanels) {
        <lm-columnar-adhoc-report-dimensions
            [spec]="spec"
            [chartName]="chartName"
            [facadeDimensions]="facadeDimensions"
            (dimensionsUpdated)="dimensionsUpdated($event)"
        ></lm-columnar-adhoc-report-dimensions>
      }
    </div>
    <div soho-tab-panel tabId="tabs-columnar-measures">
      @if (refreshTabPanels) {
        <lm-columnar-adhoc-report-measures
            [spec]="spec"
            [chartName]="chartName"
            [facadeMeasures]="facadeMeasures"
            (measuresUpdated)="measuresUpdated($event)"
        ></lm-columnar-adhoc-report-measures>
      }
    </div>
  </div>
  <div class="lm-columnar-adhoc-report-buttons-wrapper">
    <button id="lm-columnar-adhoc-report-cancel-button" type="button" class="btn-secondary" (click)="onCancel()"><span>{{cancelButtonLabel}}</span></button>
    <button id="lm-columnar-adhoc-report-apply-button" type="button" class="btn-primary" [disabled]="!isUpdated" (click)="onApply()"><span>{{applyButtonLabel}}</span></button>
  </div>
</div>
